module.exports = __webpack_public_path__ + "static/copy-dadd329bf2dbde185b5c2fc36e5dc7c7.svg";